import { useRedirect } from '@common/hooks/useRedirect';
import { getUser } from '@store/auth';
import { useAppSelector } from '@store/hooks';
import { getLocalisation } from '@store/localisation';
import { userHasBadAccountStatus } from '../../../joraEmployer/helpers/auth';

type UseRedirectAuthenticatedUserProps = {
  to?: string;
};

export function useRedirectAuthenticatedUser(
  props?: UseRedirectAuthenticatedUserProps
) {
  const { to } = props || {};
  const { currentUser, isAuthenticated } = useAppSelector(getUser);
  const { countryCode } = useAppSelector(getLocalisation);
  const { redirect } = useRedirect();

  if (isAuthenticated && !userHasBadAccountStatus(currentUser)) {
    redirect(to || `/${countryCode}/home`)();
  }
}
